import "../assets/styles/views/password-recovery.scss";
import { useOutletContext, NavLink } from "react-router-dom";
import { password_recovery } from "../utils/endpoints";

export default function PasswordRecovery() {
  const [context, setContext] = useOutletContext();

  const handleSubmit = async (e) => {
    e.preventDefault();
    let response = await context.httpRequest("post", password_recovery, {
      email: e.target.email.value,
    });
    if (response.result) {
      context.openMessage(
        "success",
        "Operazione effettuata, riceverai per e-mail una password provvisoria."
      );
      context.navigateUrl("/login");
    }
  };

  return (
    <section className="password-recovery mt-md-5 w-100 main-panel p-3">
      <div className="d-flex align-items-center">
        <h1 className="m-0">Recupera Password</h1>
        <NavLink to="/faq" className="ms-auto">
          FAQ
        </NavLink>
      </div>
      <small className="mt-3 d-block">
        Inserisci l'email per reimpostare la password
      </small>
      <form onSubmit={(e) => handleSubmit(e)}>
        <label className="d-block mt-3">EMAIL</label>
        <input name="email" type="email" className="w-100" required />

        <button className="mt-3 p-3 w-100 q8-blue-button" type="submit">
          CONFERMA
        </button>

        <span className="mt-4 text-center d-block">
          Hai già un account? <NavLink to="/login">Log in</NavLink>
        </span>
      </form>
    </section>
  );
}
